export class DateUtils {
  getMonth(index: number): string {
    return new Date(`2020-${index.toString().padStart(2, '0')}-28`).toLocaleString('es-PE', { month: 'long' });
  }
}
